/*
 * WARNING: This file was automatically generated.
 * Changes must be made to the package.templateroot, or they will be lost!
 */
export enum ILimitation {
  LowImpact = 'Low Impact',
  PregnancyFriendly = 'Pregnancy-friendly',
  FloorWork = 'Floor work',
}
